export const name = '$gzProfileImage';

export default function $gzProfileImage($mdDialog, $q) {
  'ngInject';

  let service = {
    changeUserImage: changeUserImage,
    changeOrgImage: changeOrgImage
  };

  return service;

  /////////////////

  function changeUserImage($event = null) {
    return $mdDialog.show({
      targetEvent: $event,
      template: require('./user-image.jade'),
      controller: 'userImageController',
      controllerAs: 'vm',
      bindToController: true,
      locals: {}
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        return $q.reject();
      });
  }

  function changeOrgImage($event = null) {
    return $mdDialog.show({
      targetEvent: $event,
      template: require('./org-image.jade'),
      controller: 'orgImageController',
      controllerAs: 'vm',
      bindToController: true,
      locals: {}
    })
      .then(res => {
        return res;
      })
      .catch(error => {
        return $q.reject();
      });
  }
}
